angular.module('mtic.components.dashboards.teacher_general')
.directive('classStudentPerformance', function (
      $log, 
      $q,
      $timeout, 
      EventManager, 
      StudentDataService,
      language
) {
      return {
            templateUrl: 'template.html',
            scope: {
                  classroom: '=classroom'
            },
            link: function (scope) {
                  var eventManager = new EventManager('teacherDashboard/classStudentPerformance', scope);
                  scope.getTranslation = function(id){
                        return language.get(id);
                  }
                  scope.studentWork = null;
                  scope.currentModule = '1';
                  scope.isLoading = true;
                  scope.currentSelectedStudent = null;
                  scope.viewShown = 'classTable';

                  StudentDataService.getClassStats(scope.classroom.id).then(function (studentWork) {
                        scope.studentWork = studentWork;
                        scope.isLoading = false;
                  })

                  eventManager.listen('teacher:selectStudent', function(e, student) {
                        scope.currentSelectedStudent = student;
                        scope.viewShown = 'student';
                  })

                  eventManager.listen('teacher:unselectStudent', function(e) {
                        scope.currentSelectedStudent = null;
                        scope.viewShown = 'classTable';
                  })

                  scope.goToClassManager = function() {
                        eventManager.broadcast('teacher:openView','classManager')
                  }
            }
      }
})
